import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import {Login, Register, ForgotPassword} from "../containers/auth"

class Auth extends Component {
  
  render() {
    return (
      <Switch className="auth-cntr screen">
        <Route path="/auth/login" component={Login} />
        <Route path="/auth/register" component={Register} />
        <Route path="/auth/reset-password" component={ForgotPassword} />
        <Route path="/auth/" component={Login} />
      </Switch>
    );
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/routes/Auth.js